import { useEffect, useState } from 'react';
import SlotItem from './SlotItem.js';


export default function SectionBasic({ slot, title, skin, gender, selected, randomize, setSlot, setSecondary, data }) {
    const [ items, setItems ] = useState([]);
    const thumbnailPrefix = 'https://storage.googleapis.com/glb-content-bucket/';

    useEffect(() => {
        if (!data.genders) return;

        const items = [ ];

        const item = data.genders[gender][slot];
        for(let i = 0; i < item.list.length; i++) {
            items.push(item.list[i]);
        }
        
        setItems(items);
    }, [ data, gender ]);

    return (
        <div data-slot={slot}>
            <h2 data-scroll={slot}>{title} {/*<span className='random' onClick={randomize}></span>*/}</h2>
            <ul>
                {items.map(item => {
                    let url = item.file;
                    if (skin !== undefined) url += '_' + ((skin+'').padStart(2, '0'));

                    const thumbnail = url + '.webp';

                    return <SlotItem
                        active={selected === url}
                        key={item.file}
                        gender={gender}
                        slot={slot}
                        url={url}
                        onClick={() => {
                            setSlot(url);
                            if (setSecondary) setSecondary(item.secondary ?? null);
                        }}
                        image={thumbnail}
                    />
                })}
            </ul>
        </div>
    );
}
